function cssTransition(el, addClasses, removeClasses, transtionEndProp) {
    function onEnd(event) {
        if (event.propertyName === transtionEndProp) {
            el.classList.add(addClasses[1]);
            el.classList.remove(...removeClasses.concat(addClasses[0]));
            el.removeEventListener('transitionend', onEnd);
        }
    }
    el.addEventListener('transitionend', onEnd);
    el.classList.add(addClasses[0]);
}

export function handleBurgerClick(nextState) {
    const burgerItems = document.querySelectorAll('.js-header-burger-item');
    const navHiddenElements = document.querySelectorAll('.js-hide-on-nav-is-open');

    burgerItems.forEach((item) => {
        if (nextState === 'closed') {
            cssTransition(item, ['is-closing', 'is-close'], ['is-open'], 'transform');
        } else {
            cssTransition(item, ['is-opening', 'is-open'], ['is-close'], 'transform');
        }
    });

    navHiddenElements.forEach((item) => {
        item.classList.toggle('hidden');
    });

    const mobileNav = document.querySelector('.js-mobile-nav');
    if (mobileNav) {
        mobileNav.classList.toggle('is-open');
    }

    const nyBanner = document.querySelector('.ny-banner-wrap');
    if (nyBanner) {
        if (nextState === 'open') {
            nyBanner.style.display = 'none';
        } else {
            nyBanner.style.display = 'block';
        }
    }
}

export default {
    handleBurgerClick,
};
